export const BlackBox = (props: { size: number }) => (
    <div className="black-box-container" style={{ width: `${props.size}px`, height: `${props.size}px`, border: '2px solid #000', borderRadius: '2px' }} />
  )